import { render } from "./profileAmlak.vue?vue&type=template&id=0c75eae0&scoped=true"
import script from "./profileAmlak.vue?vue&type=script&lang=js"
export * from "./profileAmlak.vue?vue&type=script&lang=js"

import "./profileAmlak.vue?vue&type=style&index=0&id=0c75eae0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c75eae0"]])

export default __exports__